import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";

function Report() {
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [allSites, setAllSites] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedSite, setSelectedSite] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedStaff, setSelectedStaff] = useState({});
  const [tasks, setTasks] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [ongoingTasks, setOngoingTasks] = useState([]);
  const [currentPageOfPendingTasks, setCurrentPageOfPendingTasks] = useState(1);
  const [currentPageOfCompletedTasks, setCurrentPageOfCompletedTasks] =
    useState(1);
  const [currentPageOfOngoingTasks, setCurrentPageOfOngoingTasks] = useState(1);

  // Function to get all staff members
  const getAllStaffs = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/user/get-all-staffs`)
      .then((response) => {
        setStaffs(response.data.staffs);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get all the sites
  const getAllSites = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/site/get-all-sites`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllSites: ", response.data);
        setAllSites(response.data.sites);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in fetching all sites: ", error);
        setLoading(false);
      });
  };

  //Function to get all the categories
  const getAllCategories = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/category/get-all-categories`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllCategories: ", response.data);
        setAllCategories(response.data.categories);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in fetching all categories: ", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setTasks([]);
    if (reportType === "Staff") {
      getAllStaffs();
    } else if (reportType === "Site") {
      getAllSites();
    } else if (reportType === "Category") {
      getAllCategories();
    }
  }, [reportType]);

  // Function to get tasks for the selected staff
  const getTasks = () => {
    setLoading(true);

    //Constructing a query parameter
    const queryParams = new URLSearchParams({
      staffId: selectedStaff?._id || "",
      category: selectedCategory?._id || "",
      site: selectedSite?._id || "",
    }).toString();
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/task/get-all-tasks/?${queryParams}`
      )
      .then((response) => {
        setTasks(response.data.tasks);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  // useEffect(() => {
  //   if (
  //     reportType &&
  //     (selectedStaff ||
  //       selectedSite ||
  //       selectedCategory ||
  //       reportType === "Task")
  //   ) {
  //     if (reportType === "Task") {
  //       // Clear all filters before fetching all tasks
  //       setSelectedStaff(null);
  //       setSelectedSite(null);
  //       setSelectedCategory(null);
  //     }
  //     getTasks();
  //   }
  // }, [selectedStaff, selectedSite, selectedCategory, reportType]);

  useEffect(() => {
    if (reportType === "Task") {
      setSelectedStaff(null);
      setSelectedSite(null);
      setSelectedCategory(null);
      getTasks(); // fetch all tasks
    } else if (
      (reportType === "Staff" && selectedStaff?._id) ||
      (reportType === "Site" && selectedSite?._id) ||
      (reportType === "Category" && selectedCategory?._id)
    ) {
      getTasks(); // fetch filtered tasks
    } else {
      setTasks([]); // clear previous tasks if filter is not selected
    }
  }, [reportType, selectedStaff, selectedSite, selectedCategory]);

  useEffect(() => {
    const pendingTasks = tasks.filter((task) => task.status === "Pending");
    const completedTasks = tasks.filter((task) => task.status === "Completed");
    const ongoingTasks = tasks.filter((task) => task.status === "Ongoing");
    setPendingTasks(pendingTasks);
    setCompletedTasks(completedTasks);
    setOngoingTasks(ongoingTasks);
  }, [tasks]);

  //Handling onChange
  const handleOnChange = (value) => {
    if (!value) {
      setTasks([]);
      setSelectedStaff(null);
      setSelectedSite(null);
      setSelectedCategory(null);
      return;
    }

    // Reset previous selections
    setSelectedStaff(null);
    setSelectedSite(null);
    setSelectedCategory(null);

    // Set selection based on report type
    switch (reportType) {
      case "Staff":
        setSelectedStaff(staffs?.find((staff) => staff._id === value));
        break;
      case "Site":
        setSelectedSite(allSites?.find((site) => site._id === value));
        break;
      case "Category":
        setSelectedCategory(
          allCategories?.find((category) => category._id === value)
        );
        break;
      default:
        break;
    }
  };

  //Pagination Logic
  const tasksPerPage = 5;

  //For Pending Tasks
  const totalPagesOfPendingTasks = Math.ceil(
    pendingTasks.length / tasksPerPage
  );

  //Function to handle page change
  const handlePageChangeOfPendingTasks = (newPage) => {
    if (newPage === 0) {
      setCurrentPageOfPendingTasks(1);
    } else if (newPage > totalPagesOfPendingTasks) {
      setCurrentPageOfPendingTasks(totalPagesOfPendingTasks);
    } else {
      setCurrentPageOfPendingTasks(newPage);
    }
  };

  //Finding the pending tasks for the current page
  const currentPendingTasks = pendingTasks?.slice(
    (currentPageOfPendingTasks - 1) * tasksPerPage,
    currentPageOfPendingTasks * tasksPerPage
  );

  //For completed tasks
  const totalPagesOfCompletedTasks = Math.ceil(
    completedTasks.length / tasksPerPage
  );

  //Function to handle page change
  const handlePageChangeOfCompletedTasks = (newPage) => {
    if (newPage === 0) {
      setCurrentPageOfCompletedTasks(1);
    } else if (newPage > totalPagesOfCompletedTasks) {
      setCurrentPageOfCompletedTasks(totalPagesOfCompletedTasks);
    } else {
      setCurrentPageOfCompletedTasks(newPage);
    }
  };

  //Finding the completed tasks for the current page
  const currentCompletedTasks = completedTasks?.slice(
    (currentPageOfCompletedTasks - 1) * tasksPerPage,
    currentPageOfCompletedTasks * tasksPerPage
  );

  //For ongoing tasks
  const totalPagesOfOngoingTasks = Math.ceil(
    ongoingTasks.length / tasksPerPage
  );

  //Function to handle page change
  const handlePageChangeOfOngoingTasks = (newPage) => {
    if (newPage === 0) {
      setCurrentPageOfOngoingTasks(1);
    } else if (newPage > totalPagesOfOngoingTasks) {
      setCurrentPageOfOngoingTasks(totalPagesOfOngoingTasks);
    } else {
      setCurrentPageOfOngoingTasks(newPage);
    }
  };

  //Finding the ongoing tasks for the current page
  const currentOngoingTasks = ongoingTasks?.slice(
    (currentPageOfOngoingTasks - 1) * tasksPerPage,
    currentPageOfOngoingTasks * tasksPerPage
  );

  const generatePDF = () => {
    const doc = new jsPDF("l"); // 'l' means landscape

    //Report Generation Date
    const reportDate = new Date()
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

    // Set Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    const title =
      reportType === "Staff"
        ? "Staff Report"
        : reportType === "Site"
        ? "Site Report"
        : reportType === "Category"
        ? "Category-wise Report"
        : "All Tasks Report";
    const pageWidth = doc.internal.pageSize.getWidth();
    const titleWidth = doc.getTextWidth(title);
    doc.text(title, (pageWidth - titleWidth) / 2, 20); // Centered title

    // Add Report Generation Date (Top-Right)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(reportDate, pageWidth - 30, 10);
    // doc.text(10, 10);

    // Report Type Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);
    if (reportType === "Staff") {
      doc.text(`Staff: ${selectedStaff?.name || "N/A"}`, 14, 30);
    } else if (reportType === "Site") {
      doc.text(`Site Name: ${selectedSite?.siteName || "N/A"}`, 14, 30);
    } else if (reportType === "Category") {
      doc.text(`Category: ${selectedCategory?.name || "N/A"}`, 14, 30);
    }

    let currentY = 40; // Initial vertical position

    // **1️⃣ Define Headers & Data Formatting**
    let headers, formatRow;
    if (reportType === "Staff") {
      headers = [
        "Sl",
        "Name",
        "Contact",
        "Category",
        "Location",
        "Start Date",
        "Time",
        "Description",
      ];
      formatRow = (task, index) => [
        index + 1,
        task?.name || "N/A",
        task?.phone || "N/A",
        task?.category?.name || "N/A",
        task?.location || "N/A",
        new Date(task?.startDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"),
        task?.time || "N/A",
        task?.description || "N/A",
      ];
    } else if (reportType === "Site") {
      headers = [
        "Sl",
        "Name",
        "Contact",
        "Category",
        "Location",
        "Start Date",
        "Time",
        "Staff",
        "Description",
      ];
      formatRow = (task, index) => [
        index + 1,
        task?.name || "N/A",
        task?.phone || "N/A",
        task?.category?.name || "N/A",
        task?.location || "N/A",
        new Date(task?.startDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"),
        task?.time || "N/A",
        task?.staffAssigned?.name || "N/A",
        task?.description || "N/A",
      ];
    } else if (reportType === "Category") {
      headers = [
        "Sl",
        "Name",
        "Contact",
        "Location",
        "Start Date",
        "Time",
        "Staff",
        "Description",
      ];
      formatRow = (task, index) => [
        index + 1,
        task?.name || "N/A",
        task?.phone || "N/A",
        task?.location || "N/A",
        new Date(task?.startDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"),
        task?.time || "N/A",
        task?.staffAssigned?.name || "N/A",
        task?.description || "N/A",
      ];
    } else if (reportType === "Task") {
      headers = [
        "Sl",
        "Name",
        "Contact",
        "Category",
        "Location",
        "Start Date",
        "Time",
        "Staff",
        "Description",
      ];
      formatRow = (task, index) => [
        index + 1,
        task?.name || "N/A",
        task?.phone || "N/A",
        task?.category?.name || "N/A",
        task?.location || "N/A",
        new Date(task?.startDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"),
        task?.time || "N/A",
        task?.staffAssigned?.name || "N/A",
        task?.description || "N/A",
      ];
    }

    // **2️⃣ Function to Generate Tables**
    const generateTable = (tasks, label, headerColor) => {
      if (tasks?.length > 0) {
        doc.setFont("helvetica", "bold");
        doc.text(`${label} - ${tasks.length}`, 14, currentY);
        doc.setFont("helvetica", "normal");

        const body = tasks.map(formatRow);

        doc.autoTable({
          startY: currentY + 5,
          head: [headers],
          body,
          theme: "grid",
          styles: { fontSize: 10, cellPadding: 2 }, // Smaller font to fit landscape
          headStyles: {
            fillColor: headerColor,
            textColor: 255,
            fontStyle: "bold",
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          tableWidth: "auto", // Ensures table adjusts to page size
        });

        currentY = doc.autoTable.previous.finalY + 10;
      }
    };

    // **3️⃣ Generate Pending & Completed Tables**
    generateTable(pendingTasks, "Pending Tasks", [255, 200, 100]); // Blue Header
    generateTable(completedTasks, "Completed Tasks", [34, 139, 34]); // Green Header
    generateTable(ongoingTasks, "Ongoing Tasks", [100, 149, 237]);

    // **4️⃣ Save PDF**
    const fileName =
      reportType === "Staff"
        ? `${selectedStaff?.name || "Staff"}-Staff Report.pdf`
        : reportType === "Site"
        ? `${selectedSite?.siteName || "Site"}-Site Report.pdf`
        : reportType === "Category"
        ? `${selectedCategory?.name || "Category"}-Category-wise Report.pdf`
        : reportType === "Task"
        ? "All Task Report.pdf"
        : "Report.pdf";

    doc.save(fileName);
  };

  return (
    <div className="mx-2 my-6 md:my-8">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-wide text-primary">
          Report
        </h1>
        <button
          className={`flex h-fit items-center gap-1 rounded bg-primary px-2 py-1 text-sm font-bold tracking-wide text-white hover:bg-hoverPrimary ${
            pendingTasks.length === 0 &&
            completedTasks.length === 0 &&
            ongoingTasks.length === 0
              ? "cursor-not-allowed"
              : "cursor-pointer"
          }`}
          onClick={generatePDF}
          disabled={
            pendingTasks.length === 0 &&
            completedTasks.length === 0 &&
            ongoingTasks.length === 0
          }
        >
          Download Report <BsDownload />
        </button>
      </div>

      <div className="my-6 flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <label className=" tracking-wide text-gray-800 ">
            Select Report Type :
          </label>
          <select
            name="reportType"
            id="reportType"
            className="w-[100%] rounded-lg border border-gray-300 p-2 px-4 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="">Select Report Type</option>
            <option value="Staff">Staff Report</option>
            <option value="Site">Site Report</option>
            <option value="Category">Category-wise Report</option>
            <option value="Task">All Tasks Report</option>
          </select>
        </div>

        <div className="flex flex-col justify-start gap-2 md:flex-row md:items-center">
          {reportType === "Staff" && (
            <div className="flex items-center gap-2">
              <label className=" tracking-wide text-gray-800 ">
                Select Staff :
              </label>
              <select
                className="w-[100%] rounded-lg border border-gray-300 p-2 px-4 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
                onChange={(e) => handleOnChange(e.target.value)}
              >
                <option value="">Select Staff</option>
                {staffs.map((staff) => (
                  <option key={staff._id} value={staff._id}>
                    {staff.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {reportType === "Site" && (
            <div className="flex items-center gap-2">
              <label className=" tracking-wide text-gray-800 ">
                Select Site :
              </label>
              <select
                name="site"
                id="site"
                className="w-[100%] rounded-lg border border-gray-300 p-2 px-4 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
                onChange={(e) => handleOnChange(e.target.value)}
              >
                <option value="">Select Site</option>
                {allSites?.map((site, index) => (
                  <option value={site._id}>{site.siteName}</option>
                ))}
              </select>
            </div>
          )}

          {reportType === "Category" && (
            <div className="flex items-center gap-2">
              <label className=" tracking-wide text-gray-800 ">
                Select Category :
              </label>
              <select
                name="site"
                id="site"
                className="w-[100%] rounded-lg border border-gray-300 p-2 px-4 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
                onChange={(e) => handleOnChange(e.target.value)}
              >
                <option value="">Select Category</option>
                {allCategories?.length > 0 ? (
                  allCategories.map((category, index) => (
                    <option value={category._id} key={index}>
                      {category?.name}
                    </option>
                  ))
                ) : (
                  <option value="">No categories</option>
                )}
              </select>
            </div>
          )}
        </div>
      </div>

      <div className="flex min-h-[70vh] flex-col overflow-x-auto">
        {loading ? (
          <table className="min-w-full">
            <tbody>
              {[...Array(10)].map((_, index) => (
                <tr
                  key={index}
                  className="animate-pulse border-b border-gray-200"
                >
                  <td className="px-6 py-4">
                    <div className="h-4 w-3/4 rounded bg-skeletonLoaderColor"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-4 rounded bg-skeletonLoaderColor"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-4 w-1/2 rounded bg-skeletonLoaderColor"></div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="h-4 w-2/3 rounded bg-skeletonLoaderColor"></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            {currentPendingTasks.length > 0 ? (
              <div>
                <h1 className="text-lg font-bold tracking-wide text-primary">
                  #Pending Tasks
                </h1>
                <table className="min-w-full overflow-y-visible rounded-md border-blue-200">
                  <thead>
                    <tr className="bg-blue-50">
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Sl
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Category
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Priority
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Start Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPendingTasks.map((task, index) => (
                      <tr
                        className="border-b border-gray-200 hover:bg-gray-50"
                        key={index}
                      >
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {(currentPageOfPendingTasks - 1) * tasksPerPage +
                            index +
                            1}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.category?.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.priority}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {new Date(task.startDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}{" "}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="float-right my-4 flex items-center justify-between gap-2 font-medium">
                  <span className="text-sm text-primaryText">
                    {currentPageOfPendingTasks} - {totalPagesOfPendingTasks}{" "}
                    pages
                  </span>
                  <div className="flex items-center gap-2">
                    <button
                      className="rounded font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfPendingTasks(
                          currentPageOfPendingTasks - 1
                        )
                      }
                    >
                      <IoIosArrowDropleft size={24} />
                    </button>

                    <button
                      className="rounded   font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfPendingTasks(
                          currentPageOfPendingTasks + 1
                        )
                      }
                    >
                      <IoIosArrowDropright size={24} />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex h-32 items-center justify-center">
                <p className="text-center tracking-wide text-gray-600">
                  No Pending Tasks
                </p>
              </div>
            )}

            {completedTasks.length > 0 ? (
              <div className="my-4">
                <h1 className="text-lg font-bold tracking-wide text-primary">
                  #Completed Tasks
                </h1>
                <table className="min-w-full overflow-y-visible rounded-md border-blue-200">
                  <thead>
                    <tr className="bg-blue-50">
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Sl
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Category
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Priority
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Start Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentCompletedTasks.map((task, index) => (
                      <tr
                        className="border-b border-gray-200 hover:bg-gray-50"
                        key={index}
                      >
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {(currentPageOfCompletedTasks - 1) * tasksPerPage +
                            index +
                            1}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.category?.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.priority}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {new Date(task.startDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}{" "}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="float-right my-4 flex items-center justify-between gap-2 font-medium">
                  <span className="text-sm text-primaryText">
                    {currentPageOfCompletedTasks} - {totalPagesOfCompletedTasks}{" "}
                    pages
                  </span>
                  <div className="flex items-center gap-2">
                    <button
                      className="rounded font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfCompletedTasks(
                          currentPageOfCompletedTasks - 1
                        )
                      }
                    >
                      <IoIosArrowDropleft size={24} />
                    </button>

                    <button
                      className="rounded   font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfCompletedTasks(
                          currentPageOfCompletedTasks + 1
                        )
                      }
                    >
                      <IoIosArrowDropright size={24} />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex h-32 items-center justify-center">
                <p className="text-center tracking-wide text-gray-600">
                  No Completed Tasks
                </p>
              </div>
            )}

            {ongoingTasks.length > 0 ? (
              <div className="my-4">
                <h1 className="text-lg font-bold tracking-wide text-primary">
                  #Ongoing Tasks
                </h1>
                <table className="min-w-full overflow-y-visible rounded-md border-blue-200">
                  <thead>
                    <tr className="bg-blue-50">
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Sl
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Category
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Priority
                      </th>
                      <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                        Start Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentOngoingTasks.map((task, index) => (
                      <tr
                        className="border-b border-gray-200 hover:bg-gray-50"
                        key={index}
                      >
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {(currentPageOfOngoingTasks - 1) * tasksPerPage +
                            index +
                            1}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.category?.name}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {task.priority}
                        </td>
                        <td className="px-6 py-4 text-sm text-primaryText">
                          {new Date(task.startDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}{" "}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="float-right my-4 flex items-center justify-between gap-2 font-medium">
                  <span className="text-sm text-primaryText">
                    {currentPageOfOngoingTasks} - {totalPagesOfOngoingTasks}{" "}
                    pages
                  </span>
                  <div className="flex items-center gap-2">
                    <button
                      className="rounded font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfCompletedTasks(
                          currentPageOfOngoingTasks - 1
                        )
                      }
                    >
                      <IoIosArrowDropleft size={24} />
                    </button>

                    <button
                      className="rounded   font-bold text-primary "
                      onClick={() =>
                        handlePageChangeOfOngoingTasks(
                          currentPageOfOngoingTasks + 1
                        )
                      }
                    >
                      <IoIosArrowDropright size={24} />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex h-32 items-center justify-center">
                <p className="text-center tracking-wide text-gray-600">
                  No Completed Tasks
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Report;
